const QmsSolutionStatus = {
    ANALYSIS_IN_PROGRESS: "analysis_in_progress",
    QUOTE_SHARED: "quote_shared",
    APPLICATION_IN_PROGRESS: "application_in_progress",
}

export default QmsSolutionStatus;
